import React from 'react';

// Плашка
export function LeavingSoonCard({ employees, onShowList }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const in30 = new Date(today);
  in30.setDate(in30.getDate() + 30);

  const leavingSoon = employees.filter((e) => {
    if (!e.dismissal_date) return false;
    const date = new Date(e.dismissal_date);
    return date >= today && date <= in30;
  });

  return (
    <div
      className="vacation-card leaving-card"
      onClick={() => onShowList()}
      title="Показать список"
    >
      <div className="vacation-icon">⚠️</div>
      <div className="vacation-info">
        <div className="vacation-label">Увольняются в течении 30 дней</div>
        <div className="vacation-value">{leavingSoon.length}</div>
      </div>
    </div>
  );
}

// Список
export function LeavingSoonList({ employees, onClose, onEmployeeClick }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const in30 = new Date(today);
  in30.setDate(in30.getDate() + 30);

  const list = employees
    .filter((e) => {
      if (!e.dismissal_date) return false;
      const date = new Date(e.dismissal_date);
      return date >= today && date <= in30;
    })
    .sort((a, b) => new Date(a.dismissal_date) - new Date(b.dismissal_date));

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('ru-RU');
  };

  const daysUntil = (date) => {
    if (!date) return '';
    const target = new Date(date);
    target.setHours(0, 0, 0, 0);
    const diff = Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'сегодня';
    if (diff === 1) return 'завтра';
    if (diff < 0) return 'просрочено';
    return `через ${diff} дн.`;
  };

  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Увольняются в течение 30 дней — {list.length}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {list.length === 0 ? (
            <div className="empty" style={{ padding: '30px' }}>
              Никто не увольняется в ближайшие 30 дней
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th className="col-tab">Табель</th>
                  <th>ФИО</th>
                  <th>Дата увольнения</th>
                  <th style={{ width: '100px' }}></th>
                </tr>
              </thead>
              <tbody>
                {list.map((emp) => (
                  <tr
                    key={emp.id}
                    onClick={() => onEmployeeClick(emp)}
                    className="leaving-soon-row"
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="col-tab-value">{emp.tab_number || '—'}</td>
                    <td className="emp-name">
                      <div className="emp-name-cell">
                        <div className={`emp-avatar ${emp.gender === 'м' ? 'male' : 'female'}`}>
                          {getInitials(emp.full_name)}
                        </div>
                        {emp.full_name}
                      </div>
                    </td>
                    <td>{formatDate(emp.dismissal_date)}</td>
                    <td style={{ fontSize: '11px', color: '#c62828', textAlign: 'right', fontWeight: 600 }}>
                      {daysUntil(emp.dismissal_date)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-footer-right">
            <button className="btn-cancel" onClick={onClose}>Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  );
}